import React from "react";
import * as s from "./index.module.scss";
import { Star } from "react-ionicons";
import Quotation from "../../../images/TrustedByMany/quotation.svg";

const ReviewCard = ({ data }) => {
  return (
    <div className={s.review_card}>
      <div className="">
        <img loading="lazy" src={Quotation.src} alt="image" />
        <div className={s.review_text}>{data.review}</div>
      </div>
      <div className="">
        <div className={s.reviewer_name}>{data.name}</div>
        <div className={s.ratings}>
          {Array.from({ length: data.rating }, (_, idx) => (
            <Star key={idx} color={"#fdb022"} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
